import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import NoPlanIdRouting from "./NoPlanIdPages/NoPlanIdRouting";
import PlanIdRouting from "./PlanIdPages/PlanIdRouting";

const PlanAdminRouting = () => {

    let {planIdOrCmd} = useParams();

    const [isPlanIdPath, setIsPlanIdPath] = useState(null);

    useEffect(() => {

      if(isNumeric(planIdOrCmd))
      {
        setIsPlanIdPath(true);
      }

    }, [planIdOrCmd]);

    function isNumeric(str) {
      const num = parseFloat(str);
      return !isNaN(num) && isFinite(num);
    }

    return (
    <>
      {isPlanIdPath ?
        <PlanIdRouting />
      : <NoPlanIdRouting />}
    </>
  );

};

export default PlanAdminRouting;